import React from "react";
import { getSuperAdmin } from "../controllers/superAdminController";
import "./SuperAdminBar.css";
import FieldHelp from "../help/FieldHelp";

/**
 * Mode banner shown above the header while a super admin is signed in.
 *
 * Renders nothing for an ordinary client session. It is purely an indicator:
 * which client is being viewed, and switching between them, both live in the
 * header pill (SuperAdminClientSwitcher). The only job here is that an elevated
 * session can never be mistaken for a normal one.
 */
const SuperAdminBar = () => {
  const superAdmin = getSuperAdmin();
  if (!superAdmin?.username) return null;

  return (
    <div className="sa-bar" role="status">
      <span className="sa-bar-chip">
        <svg
          className="sa-bar-shield"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
        <FieldHelp id="common.superAdminMode">Super Admin</FieldHelp>
      </span>
    </div>
  );
};

export default SuperAdminBar;
